import authUser from '~/modules/auth/authUser'

export default function ({ store, redirect, error }) {
  const user = authUser.get()
  const isPawnshop = user && user.organization && user.organization.isPawnshop
  if (!isPawnshop) {
    return redirect('/dashboard')
  }
}
